const listInitialValue = '<ul><li></li></ul>';

export default listInitialValue;
